import styled, { keyframes } from "styled-components";
import colors from "../../styles/colors";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: ${colors.background.gradient};
  padding: 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle at 30% 20%,
      ${colors.loader.muted} 0%,
      transparent 50%
    );
    pointer-events: none;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 24px;
  padding: 3rem 4rem;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.08),
    0 8px 25px rgba(0, 0, 0, 0.05);
  text-align: center;
  max-width: 480px;
  width: 100%;
  animation: ${fadeIn} 0.6s ease-out;
  position: relative;
  z-index: 1;

  @media (max-width: 520px) {
    padding: 2rem 1.5rem;
    border-radius: 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LogosContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;

  img {
    height: 120px;
  }
`;

export const Message = styled.p`
  font-family: "Poppins", "Segoe UI", sans-serif;
  font-size: 1rem;
  color: ${colors.text.subtitle};
  margin-top: 1rem;
`;
